import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M16.778 3.333H3.222a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.334v3.878a.5.5 0 0 0 .834.372l4.721-4.25h5.667a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    }, null, -1)
  ]))]))
}
export default { render: render }